import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './StatusGood.module.css';
import { CommonButton } from '_components';


export class StatusGood extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        const customStyle = this.props.backgroundColor
        ? { backgroundColor: this.props.backgroundColor }
        : {};

        const iconColor = this.props.color || 'white'; // default to white
        return (
            <CommonButton 
            title={this.props.title ? this.props.title : 'Good'} 
            onClick={this.props.onClick} 
            size={this.props.size} 
            style={customStyle}
            className={this.props.backgroundColor ??cls} 
            type='round' >
                <FontAwesomeIcon icon={faCheck} transform="shrink-5" color={iconColor} />
            </CommonButton>
        );
    }
}

